import { Component } from '@angular/core';
import { UpdateCard as UpdateCardInterface } from '../../data/interfaces/UpdateCardInterface';
import { UPDATES } from '../../data/updates.data';
import { UpdateCard } from '../update-card/update-card';
import { WideUpdateCard } from '../wide-update-card/wide-update-card';

@Component({
  selector: 'app-updates',
  imports: [UpdateCard, WideUpdateCard],
  templateUrl: './updates.html',
  styleUrl: './updates.scss',
})
export class Updates {
  public updates: Array<UpdateCardInterface> = UPDATES



}
